export const CATEGORIES = [
  "All",
  "Meghalaya",
  "Assam",
  "Arunachal Pradesh",
  "Travel Tips",
  "Adventure",
  "Food & Culture",
  "Road Trips",
];

const AUTHOR = "RandZ Tours & Travels";

export const ARTICLES = [
  {
    slug: "top-10-places-to-visit-in-meghalaya",
    title: "Top 10 Places to Visit in Meghalaya",
    excerpt:
      "From the living root bridges of Nongriat to the crystal Umngot at Dawki — the ten places every first-time traveller should put on the Meghalaya map.",
    cover: "https://images.unsplash.com/photo-1698429358246-807d8972da9a?w=1600&q=80",
    category: "Meghalaya",
    readTime: 8,
    date: "2026-01-12",
    author: AUTHOR,
    featured: true,
    seo: "Best places to visit in Meghalaya 2026 — Shillong, Cherrapunji, Dawki, Mawlynnong, Nongriat living root bridges and more.",
  },
  {
    slug: "complete-dawki-travel-guide",
    title: "The Complete Dawki Travel Guide",
    excerpt: "When to go, where to stay, how to get the clearest boat ride on the Umngot, and the quiet Shnongpdeng alternative just upstream.",
    cover: "https://images.unsplash.com/photo-1626621934130-58def2dbd4d2?w=1600&q=80",
    category: "Meghalaya",
    readTime: 6,
    date: "2026-01-05",
    author: AUTHOR,
    seo: "Dawki Meghalaya travel guide — Umngot river boating, best time to visit, Shnongpdeng camping, India-Bangladesh border.",
  },
  {
    slug: "best-time-to-visit-cherrapunji",
    title: "The Best Time to Visit Cherrapunji",
    excerpt: "Sohra has two moods — wettest place on earth and bluest sky in the East. Here's how to plan for the version you want.",
    cover: "https://images.unsplash.com/photo-1605649461784-edc01d49d09f?w=1600&q=80",
    category: "Travel Tips",
    readTime: 5,
    date: "2025-12-22",
    author: AUTHOR,
    seo: "Best time to visit Cherrapunji Sohra Meghalaya — monsoon vs winter waterfalls Nohkalikai.",
  },
  {
    slug: "ultimate-tawang-road-trip",
    title: "The Ultimate Tawang Road Trip",
    excerpt: "Guwahati to Tawang in seven days — Sela Pass, Madhuri Lake, Bumla, and the highest motorable monastery in India.",
    cover: "https://images.unsplash.com/photo-1628443266300-e8490ee38875?w=1600&q=80",
    category: "Road Trips",
    readTime: 10,
    date: "2025-12-15",
    author: AUTHOR,
    seo: "Tawang road trip itinerary — Sela Pass, Bomdila, Dirang, inner line permit, Madhuri Lake.",
  },
  {
    slug: "hidden-gems-of-meghalaya",
    title: "Hidden Gems of Meghalaya",
    excerpt: "Beyond the postcards: Krang Suri, Wei Sawdong, Mawphlang sacred grove and other corners only locals talk about.",
    cover: "https://images.unsplash.com/photo-1742494267580-e026d3737f65?w=1600&q=80",
    category: "Meghalaya",
    readTime: 7,
    date: "2025-12-02",
    author: AUTHOR,
    seo: "Offbeat hidden places in Meghalaya — Krang Suri, Wei Sawdong, Mawphlang sacred grove, Laitlum.",
  },
  {
    slug: "best-cafes-in-shillong",
    title: "The Best Cafés in Shillong",
    excerpt: "Slow mornings, sourdough, and Khasi pop playlists — the Shillong café trail every traveller should walk.",
    cover: "https://images.unsplash.com/photo-1611042553484-d61f84d22784?w=1600&q=80",
    category: "Food & Culture",
    readTime: 4,
    date: "2025-11-18",
    author: AUTHOR,
    seo: "Best cafes in Shillong Meghalaya — Dylan's, Café Shillong, ML 05, café culture.",
  },
  {
    slug: "kaziranga-safari-guide",
    title: "Your Kaziranga Safari Guide",
    excerpt: "Choosing between zones, jeep vs. elephant safaris, photography tips and the best time to spot the one-horned rhino.",
    cover: "https://images.unsplash.com/photo-1549366021-9f761d450615?w=1600&q=80",
    category: "Assam",
    readTime: 7,
    date: "2025-11-04",
    author: AUTHOR,
    seo: "Kaziranga National Park safari guide — central western eastern range, rhino tiger elephant, booking tips.",
  },
  {
    slug: "meghalaya-packing-guide",
    title: "The Meghalaya Packing Guide",
    excerpt: "Layers, rain shells, leech socks and the one piece of gear most travellers forget — packed light, packed right.",
    cover: "https://images.unsplash.com/photo-1601200351837-87d31f7a8d76?w=1600&q=80",
    category: "Travel Tips",
    readTime: 4,
    date: "2025-10-20",
    author: AUTHOR,
    seo: "Meghalaya packing list monsoon winter — rain jacket, leech socks, layers, what to carry.",
  },
];
